import { createContext, Dispatch } from 'react';
import { Event } from './useGenerateTokenModalReducer';

export const GenerateTokenModalContext = createContext<{ dispatch: Dispatch<Event> }>({ dispatch: () => {} });
